import React from 'react';
import { AlertTriangle } from 'lucide-react';

const FeatureDisclaimer = ({ type = 'general' }) => {
  const disclaimers = {
    exercise: 'Exercise demonstrations are for informational purposes only. Consult a certified trainer before attempting new exercises. You assume all risk of injury.',
    nutrition: 'AI nutritional estimates are approximate. Consult a registered dietitian for personalized advice. Not a substitute for professional medical guidance.',
    scanner: 'Calorie estimates are AI-generated approximations and may vary from actual values. Verify allergens independently.',
    mealplan: 'AI-generated meal plans are suggestions only. Verify ingredients for allergies. Consult a healthcare professional for medical dietary needs.',
    general: 'This information is for educational purposes only. Not medical advice. Consult a healthcare professional before making health decisions.'
  };

  return (
    <div className="flex items-start gap-2 px-3 py-2 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700/50 rounded-lg" data-testid={`disclaimer-${type}`}>
      <AlertTriangle size={14} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
      <p className="text-xs text-amber-700 dark:text-amber-300">{disclaimers[type]}</p>
    </div>
  );
};

export default FeatureDisclaimer;
